<template>
  <div class="wrapper-progressBar">
    <ul class="progressBar">
      <li
        v-for="(step, index) in steps"
        :key="index + 1"
        :class="{
          active: index + 1 === activeStep,
          complete: index + 1 < activeStep,
        }"
        :style="{ zIndex: stepCount - index }"
      >
        {{ step.title }}
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    steps: {
      type: Array,
      required: true,
    },
    activeStep: {
      type: Number,
      required: true,
    },
  },
  computed: {
    stepCount(): number {
      return this.steps.length || 0;
    },
  },
});
</script>

<style scoped>
.wrapper-progressBar {
  width: 100%;
}

.progressBar {
  display: flex;
  justify-content: space-between;
  padding: 0;
}

.progressBar li {
  list-style-type: none;
  width: 33%;
  position: relative;
  text-align: center;
  z-index: 0;
}

.progressBar li:before {
  content: " ";
  line-height: 30px;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  border: 1px solid #ddd;
  display: block;
  text-align: center;
  margin: 0 auto 10px;
  background-color: white;
}

.progressBar li:after {
  content: "";
  position: absolute;
  width: 100%;
  height: 4px;
  background-color: #ddd;
  top: 14px;
  left: -46%;
  z-index: -1;
}

.progressBar li:first-child:after {
  content: none;
}

.progressBar li.active {
  color: var(--theme-color);
}

.progressBar li.active:before,
.progressBar li.complete:before {
  border-color: var(--theme-color);
  background-color: var(--theme-color);
}

.progressBar .active:after,
.progressBar .complete:after {
  background-color: var(--theme-color);
}

.progressBar .complete:before {
  content: "✔";
  font-size: 23px;
}

.wrapper-progressBar .cusc-dark {
  color: white;
}
</style>
